type DownArrowProps = {
  className?: string;
};

export const DownArrow: import('react').FC<DownArrowProps> = ({ className }) => (
  <svg width="14" height="10" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="icon-down-arrow" className={className}>
    <path d="M1 1L4.5 4L8 1" stroke="black" strokeWidth="1" strokeLinejoin="round" />
  </svg>
);
